import Vue from "vue";
import Router from "vue-router";
import Home from "../pages/Home.vue";
import Detail from "../components/Detail.vue";
import AppList from "../components/AppList.vue";
import AppArticle from "../components/AppArticle.vue";
import AboutMe from "../components/AboutMe.vue";

Vue.use(Router);

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition;
  } else {
    const position = {};

    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash;

      // specify offset of the element
      if (to.hash === "#anchor2") {
        position.offset = { y: 100 };
      }

      // bypass #1number check
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position;
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false;
    }

    return new Promise((resolve) => {
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some((m) => m.meta.scrollToTop)) {
        // coords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0;
        position.y = 0;
      }

      // wait for the out transition to complete (if necessary)
      this.app.$root.$once("triggerScroll", () => {
        // if the resolved position is falsy or an empty object,
        // will retain current scroll position.
        resolve(position);
      });
    });
  }
};

export default new Router({
  routes: [
    {
      path: "/",
      component: Home,
      name: "main",
      meta: {
        title: "All application",
      },
      children: [
        {
          path: "",
          component: AppList,
          name: "all",
          meta: {
            title: "All application!",
            isRoot: true,
          },
        },
        {
          path: "ios",
          component: AppList,
          name: "ios",
          meta: {
            title: "All iOS application!",
            isRoot: true,
          },
        },
        {
          path: "android",
          component: AppList,
          name: "android",
          meta: {
            title: "All android application!",
            isRoot: true,
          },
        },
      ],
    },
    {
      path: "/detail/:id",
      component: Detail,
      name: "detail",
      meta: {
        scrollToTop: true,
      },
    },
    {
      path: "/article/:id",
      component: AppArticle,
      name: "article",
      meta: {
        scrollToTop: true,
      },
    },
    {
      path: "/about",
      component: AboutMe,
      name: "about",
      meta: {
        scrollToTop: true,
      },
    },
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/components/PageNotFound.vue'),
      name: "PageNotFound",
      meta: {
        title: "PageNotFound",
        isPersonal: false,
      },
    },
  ],
  mode: "history",
  scrollBehavior,
  // scrollBehavior(to, from, saved) {
  //   console.log("saved", saved);
  //   if (saved) {
  //     return saved;
  //   }

  //   if (to.hash) {
  //     return {
  //       selector: to.hash,
  //     };
  //   }
  //   return {
  //     x: 0,
  //     y: 0,
  //   };
  // },
});
